import React, { useEffect, useState } from "react";
import { Box, Flex, BoxProps, useColorModeValue, useMediaQuery } from "@chakra-ui/react";
import { motion } from "framer-motion";
import HomeButton from "./HomeButton/HomeButton";
import NavLinks from "./LinksButton/NavLinks";
import UserMenu from "./MenuButton/UserMenu";
import HomeButtonMobil from "./HomeButton/HomeButtonMobil";
import AnimatedMenuPhone from "./MenuButton/UserMenuPhone";

const MotionBox = motion<BoxProps>(Box);

const SideDrawer: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isMobile] = useMediaQuery("(max-width: 1284px)");

    // Détecte si on a scrollé pour changer l'apparence de la navbar
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const bgScrolled = useColorModeValue(
        "rgba(244, 243, 239, 0.88)",
        "rgba(10, 22, 40, 0.88)"
    );
    const bgTop = "transparent";

    const borderScrolled = useColorModeValue(
        "rgba(10, 22, 40, 0.07)",
        "rgba(255, 255, 255, 0.06)"
    );

    // Animation d'entrée initiale — stagger sur les enfants
    const containerVariants = {
        hidden: { opacity: 0, y: -16 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.16, 1, 0.3, 1],
                staggerChildren: 0.08,
                delayChildren: 0.1,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: -10 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
        },
    };

    return (
        <MotionBox
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex={1000}
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            // Transition douce entre transparent et frosted glass au scroll
            style={{
                backdropFilter: scrolled ? "blur(20px) saturate(180%)" : "none",
                backgroundColor: scrolled ? bgScrolled : bgTop,
                borderBottom: scrolled ? `1px solid ${borderScrolled}` : "1px solid transparent",
                transition: "background-color 0.5s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.5s cubic-bezier(0.16, 1, 0.3, 1), backdrop-filter 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
            }}
            px={{ base: 4, md: 8 }}
        >
            <Flex
                h={{ base: "60px", md: "68px" }}
                alignItems="center"
                justifyContent="space-between"
            >
                {/* ── Logo ── */}
                <MotionBox variants={itemVariants} flexShrink={0}>
                    {isMobile ? <HomeButtonMobil /> : <HomeButton />}
                </MotionBox>

                {/* ── Liens centraux (desktop uniquement) ── */}
                {!isMobile && (
                    <MotionBox variants={itemVariants} flex="1" display="flex" justifyContent="center">
                        <NavLinks />
                    </MotionBox>
                )}

                {/* ── Menu droite ── */}
                <MotionBox variants={itemVariants} flexShrink={0}>
                    {isMobile ? <AnimatedMenuPhone /> : <UserMenu />}
                </MotionBox>
            </Flex>
        </MotionBox>
    );
};

export default SideDrawer;